<div class="m-header">
    <button class="m-header__btn" type="button" (click)="toggleSidebarEvent.emit()">
        <nb-icon [icon]="sideBarState === 'expanded' ? 'close-outline' : 'menu-outline'" status="basic"></nb-icon>
    </button>

    <a class="m-header__logo" [routerLink]="['/cabinet']">
        <img src="/assets/images/logo.svg" height="40" alt="Логотип" />
    </a>

    <button class="m-header__btn" type="button" (click)="toggleSearchEvent.emit()">
        <nb-icon [icon]="isShowSearch ? 'arrow-back-outline' : 'search-outline'" status="basic"></nb-icon>
    </button>

    <div class="m-header__search" [class.m-header__search--visible]="isShowSearch">
        <app-search-autocomplete></app-search-autocomplete>
        <button class="m-header__btn m-header__search-close" type="button" (click)="toggleSearchEvent.emit()">
            <nb-icon icon="close-outline" status="basic"></nb-icon>
        </button>
    </div>
</div>
